import { Action } from '@ngrx/store';

export const ORDER_PAY_AND_GO = 'ORDER_PAY_AND_GO';
export const ORDER_PAY_AND_GO_SUCCESS = 'ORDER_PAY_AND_GO_SUCCESS';
export const ORDER_PAY_AND_GO_FAILURE = 'ORDER_PAY_AND_GO_FAILURE';
export const CLOSE_PAY_AND_GO_MODAL = 'CLOSE_PAY_AND_GO_MODAL';
export const RESET_PAY_AND_GO = 'RESET_PAY_AND_GO';

export class OrderPayAndGo implements Action {
  type = ORDER_PAY_AND_GO;

  constructor(public payload: any) {}
}

export class OrderPayAndGoSuccess implements Action {
  type = ORDER_PAY_AND_GO_SUCCESS;

  constructor(public payload: any) {}
}
export class OrderPayAndGoFailure implements Action {
  type = ORDER_PAY_AND_GO_FAILURE;

  constructor(public payload: any) {}
}

export class ClosePayAndGoModal implements Action {
  type = CLOSE_PAY_AND_GO_MODAL;

  constructor() {}
}

export class ResetPayAndGo implements Action {
  type = RESET_PAY_AND_GO;

  constructor() {}
}

export type Actions =
  | OrderPayAndGo
  | OrderPayAndGoSuccess
  | OrderPayAndGoFailure
  | ClosePayAndGoModal
  | ResetPayAndGo;
